export const getGeofencing = (state) => state.geofencing;
export const getSelectedGeofencingCrowns = (state) => state.geofencing?.selectedCrowns ?? [];
